//export const apiUrl = "https://s2m-admin-backend-dev-jozsyq55pq-as.a.run.app"; //uat

//export const apiUrl = "http://localhost:3000/"; //test

export const apiUrl = "https://admin-api.stock2morrow.com/"; //production